// removed by extract-text-webpack-plugin
module.exports = {"collectionCard":"_1YUYmhUalEEDgDXZ3_h6K5","card":"_3s8B99H6gNjsml-n9AxoE","thumbnail":"_3h1koeW4esOgixRd507tqy","totalItem":"_1pw-pEmjlMUPx5qCV8D-sc","quantity":"_2u_OX8fFmgwdmhAr9J1lPX","text":"_35RQ2FYPdd2bwUqXThZJ8A","content":"_3vkSWs1uFK97ezQta_XTn0","description":"nLkTcBSRXEAc0KhpDI3Ny","likesCmt":"_14amrf35jLo3aj-KbNlI-_","left":"_1WNC7GdGhNlNbv8Z4Dtw4L","like":"_2zJoQ71yXSnv6T2PKnz1jw","right":"_1WfLwbqEQwEyvSyS9mIQdX","cardStack1":"_1-ffoRzUdrmGFnbh42Om6W","cardStack2":"_2Q2Q7SAQBOHHWi39_JGps"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/CollectionCard.scss
// module id = 1080
// module chunks = 0